import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '../services/notification/notification.service';
import { LocalstorageService } from '../services/localstorage/localstorage.service';
import { environment } from 'src/environments/environment';
import { LocalstorageConstant } from '../constants/localstorage-constant';

@Injectable()
export class HttpsRequestInterceptor {
  constructor(
    private router: Router,
    private localstorageService: LocalstorageService,
    private notificationService: NotificationService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.url === (environment.BACKEND.BASE_URL + environment.BACKEND.LOGIN) &&
      request.method === 'POST') {
      return next.handle(request).pipe(catchError(error => this.errorHandler(error)));
    }

    if (!request.url.startsWith(environment.BACKEND.BASE_URL)) {
      return next.handle(request).pipe(catchError(error => this.errorHandler(error)));
    }

    if (!this.localstorageService.getItem(LocalstorageConstant.TOKEN)) {
      this.resetCredentials();
    }

    return next.handle(this.includeToken(request)).pipe(catchError(error => this.errorHandler(error)));
  }

  includeToken<T>(request: HttpRequest<T>): HttpRequest<T> {
    const authorizedRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.localstorageService.getItem(LocalstorageConstant.TOKEN)}`
      }
    });
    return authorizedRequest;
  }

  resetCredentials() {
    this.localstorageService.destroy();
  }

  private errorHandler(response: HttpErrorResponse | null): Observable<HttpEvent<any>> {

    switch (response.status) {
      case 0:
        this.resetCredentials();
        this.router.navigateByUrl('/');
        break;
      case 401:
        this.resetCredentials();
        this.notificationService.open('Sua sessão expirou. Por favor, entre novamente com o login e senha.', { type: 'warning' });
        this.router.navigateByUrl('/');
        break;
      case 400:
        console.log(response.error.Message);
        this.notificationService.open(response.error.Message, { type: 'danger' });
        break;
      case 404:
        this.notificationService.open('O recurso requisitado não existe.', { type: 'danger' });
        break;
      case 500:
        this.notificationService.open(response.error.Message, { type: 'danger' });
        break;
    }

    throw response;
  }
}
